export default __webpack_public_path__ + "static/CookieRun-Bold-07162854e5b0889acf82586e7f44bd88.ttf";